import { render, staticRenderFns } from "./Grafico2.vue?vue&type=template&id=9f8150dc&"
import script from "./Grafico2.vue?vue&type=script&lang=js&"
export * from "./Grafico2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports